/**
 * Live fund list for components that need `ApiFundListItem` shape (e.g.
 * `LeveragedHoldingsTable` — checks whether an underlying ETF is live to
 * surface a "View <underlying> Page →" CTA).
 *
 * Wraps `useFundList` and re-maps to the narrower three-field shape that
 * existing consumers depend on.
 */
import { useFundList } from "./use-fund-list";

export interface ApiFundListItem {
  ticker: string;
  slug: string;
  full_name: string;
}

export function useEtfFundList(): {
  funds: ApiFundListItem[];
  isPending: boolean;
  isError: boolean;
} {
  const { data, isPending, isError } = useFundList();

  // DDB uses `id` for the URL slug and `fullName` (nullable).
  const funds: ApiFundListItem[] = (data ?? []).map((f) => ({
    ticker: f.ticker,
    slug: f.id,
    full_name: f.fullName ?? f.name,
  }));

  return { funds, isPending, isError };
}
